import { array, string } from 'fp-ts';
import { ActionLogEntityType } from '@mews-commander/types';
import { getNowUtc } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { logActionLogInit } from '@mews-commander/legacy-entities/src/actions/actionLogs';
import { fetchActionLogItems, fetchCurrentEnterpriseBillsByIds } from '@mews-commander/legacy-entities/src/actions';
import { getBill } from '@mews-commander/legacy-entities/src/ducks';
import { getActionLogItemsByEntityOrOwnerId } from '@mews-commander/legacy-entities/src/ducks/actionLogItems';
import { FULL_BILL_EXTENT, DEFAULT_BILL_FETCH_EXTENT } from '@mews-commander/legacy-entities/src/actions/bills';
import { getProductIdsByOrderItemIds } from '@mews-commander/legacy-entities/src/selectors/products';
import { fetchProducts } from '@mews-commander/legacy-entities/src/actions/products';
import { ORDER_ITEM_EXTENT } from '../../constants';
import { fetchOrderItems } from '../../../billing/actions/orderItems';
import { changeDocumentTitle } from '../../../../middleware';
import { getUtcTimeOneSecondEarlierFromUtcDate } from '../../utils';

const BILL_EXTENT = {
    ...FULL_BILL_EXTENT,
    products: false,
};

// @ts-expect-error removed universal router RouteLeaf['fetchDependency']
const initializeBillActionLog = async ({ dispatch, getState }, { id: billId }) => {
    const startTime = window.performance.now();
    if (!Array.isArray(billId)) {
        await dispatch(
            fetchCurrentEnterpriseBillsByIds({
                billIds: [billId],
                extent: { ...DEFAULT_BILL_FETCH_EXTENT, ...BILL_EXTENT },
            })
        );
    }

    const state = getState();
    const bill = getBill(state, { id: billId as string });
    const enterpriseId = getCurrentEnterpriseId();

    if (!bill) throw new Error(`Bill with id ${billId as string} not found`);

    if (bill.name) {
        dispatch(changeDocumentTitle(bill.name));
    }

    const createdUtc = {
        startUtc: getUtcTimeOneSecondEarlierFromUtcDate(state, { utc: bill.createdUtc }),
        endUtc: getNowUtc(),
    };

    const entityFilters = [
        {
            ownerIds: [billId as string],
            entityTypeNames: [ActionLogEntityType.OrderItem],
        },
        {
            entityIds: [billId as string],
            entityTypeNames: [ActionLogEntityType.Bill],
        },
    ];

    const promise = entityFilters.map((entityFilter) =>
        dispatch(fetchActionLogItems({ enterpriseIds: [enterpriseId], createdUtc, entityFilters: [entityFilter] }))
    );

    await Promise.all(promise);

    const actionLogItems = getActionLogItemsByEntityOrOwnerId(getState(), { entityId: billId as string });
    const orderItems = actionLogItems.filter((item) => item.entityType === ActionLogEntityType.OrderItem);

    if (orderItems.length > 0) {
        const orderItemIds = array.uniq(string.Eq)(orderItems.map((item) => item.entityId));
        await dispatch(fetchOrderItems({ orderItemIds, extent: ORDER_ITEM_EXTENT }));

        const productIds = getProductIdsByOrderItemIds(getState(), { ids: orderItemIds });

        if (productIds.length) {
            await dispatch(fetchProducts({ productIds }));
        }
    }

    return dispatch(logActionLogInit({ entityId: billId as string, entityType: ActionLogEntityType.Bill, startTime }));
};

export default initializeBillActionLog;
